import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, Check, Link2, Globe } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import api from "../lib/apiClient";

export default function ShareDialog({ open, onOpenChange, plan, onShared }) {
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(plan?.share_token || null);

  const shareUrl = token ? `${window.location.origin}/shared/${token}` : "";

  const generate = async () => {
    setLoading(true);
    try {
      const res = await api.post(`/plans/${plan.plan_id}/share`);
      setToken(res.data.share_token);
      onShared && onShared(res.data.share_token);
    } catch (e) {
      toast.error("Could not create share link");
    } finally {
      setLoading(false);
    }
  };

  const copy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    toast.success("Link copied");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="share-dialog" className="bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><Globe className="h-5 w-5 text-indigo-400" /> Share this plan</DialogTitle>
          <DialogDescription className="text-slate-400">Anyone with the link can view a read-only copy.</DialogDescription>
        </DialogHeader>

        {!token ? (
          <Button data-testid="generate-share-button" onClick={generate} disabled={loading} className="cta-btn">
            <Link2 className="h-4 w-4 mr-2" /> {loading ? "Generating…" : "Generate public link"}
          </Button>
        ) : (
          <div className="space-y-4">
            <div className="flex gap-2">
              <Input data-testid="share-url-input" readOnly value={shareUrl} className="bg-slate-800 border-slate-700 text-slate-200" />
              <Button data-testid="copy-share-button" onClick={copy} className="cta-btn shrink-0">
                {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
              </Button>
            </div>
            <div className="flex justify-center rounded-xl bg-white p-4 w-fit mx-auto">
              <QRCodeCanvas value={shareUrl} size={140} />
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
